<span class="label-preview">
  @if (iconSrc) {
    <img class="label-preview__icon" [src]="iconSrc" alt="" />
  }
  <span class="label-preview__text" [innerHTML]="options?.text ?? '' | safe"></span>
</span>
